import { setRegionId } from '../../repositories/header-frontend/v1/set-region-id/helpers';
import { openAuthModal } from '../../repositories/header-frontend/v2/open-auth-modal/helpers';

import type { IMicrofrontendsAPI } from '../../../shared/common/services/microfrontends/types';

export function createMicrofrontendsAPI(): IMicrofrontendsAPI {
  return {
    header: {
      setRegionId,
      openAuthModal,
    },
  };
}
